import { render, staticRenderFns } from "./AccordionItemAlgoServer.vue?vue&type=template&id=0c6b8118&scoped=true"
import script from "./AccordionItemAlgoServer.vue?vue&type=script&lang=js"
export * from "./AccordionItemAlgoServer.vue?vue&type=script&lang=js"
import style0 from "./AccordionItemAlgoServer.vue?vue&type=style&index=0&id=0c6b8118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b8118",
  null
  
)

export default component.exports